import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { baseUrl } from './../../../../../app.config'
import axios from 'axios'

export const getPendingTopics = createAsyncThunk(
  'reports/getPendingTopics',
  async (params) => {
    const response = await axios.get(
      baseUrl() + '/user-topic/pending-topic-by-user',
      { params }
    )
    return {
      allPendingTopics: response?.data?.data || [],
      totalPages: response?.data?.count?.total || 0
    }
  }
)
export const PendingTopics = createSlice({
  name: 'pendingTopicsMaster',
  initialState: {
    allPendingTopics: [],
    loader: false,
    params: {
      pageNo: 1,
      pageSize: 25,
      status : "0,1,2"
    },
    totalPages: 0,
    filterData: {
      status : "0,1,2"
    },
    clearFilter : true
  },
  reducers: {
    setParams: (state, action) => {
      state.params = action.payload
    },
    setPageNo: (state, action) => {
      state.params.pageNo = action.payload
    },
    setPageSize: (state, action) => {
      state.params.pageSize = action.payload
    },
    setFilterData: (state, action) => {
      if (action.payload === null) {
        state.filterData = null
      } else {
        state.filterData = action.payload
      }
    },
    selectClearFilter: (state, action) => {
      state.clearFilter = action.payload
    },
    setLoader: (state, action) => {
      state.loader = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPendingTopics.fulfilled, (state, action) => {
        state.loader = false
        state.allPendingTopics = action.payload.allPendingTopics
        state.totalPages = action.payload.totalPages
      })
      .addCase(getPendingTopics.pending, (state) => {
        state.loader = true
      })
      .addCase(getPendingTopics.rejected, (state) => {
        state.loader = false
      })
  }
})
export const {
  setParams,
  setPageNo,
  setPageSize,
  setFilterData,
  selectClearFilter,
  setLoader
} = PendingTopics.actions

export default PendingTopics.reducer
